import { render, staticRenderFns } from "./ArtistCreateNew.vue?vue&type=template&id=094e1d06&"
import script from "./ArtistCreateNew.vue?vue&type=script&lang=js&"
export * from "./ArtistCreateNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports